import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "admin-layout" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = { class: "logo-container" }
const _hoisted_4 = {
  key: 0,
  class: "logo-text"
}
const _hoisted_5 = { class: "sidebar-nav" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "badge-nav"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "badge-nav"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "badge-nav"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "nav-divider"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "sidebar-footer" }
const _hoisted_18 = {
  key: 0,
  class: "user-info"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "user-name" }
const _hoisted_21 = { class: "user-role" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "admin-header" }
const _hoisted_24 = { class: "header-left" }
const _hoisted_25 = { class: "header-right" }
const _hoisted_26 = { class: "header-search" }
const _hoisted_27 = {
  key: 0,
  class: "notif-badge"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "admin-content" }
const _hoisted_30 = { class: "notif-header" }
const _hoisted_31 = {
  key: 0,
  class: "notif-empty"
}
const _hoisted_32 = {
  key: 1,
  class: "notif-items"
}
const _hoisted_33 = { class: "notif-content" }
const _hoisted_34 = { class: "notif-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMobileOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sidebar-overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileSidebar && _ctx.toggleMobileSidebar(...args)))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("aside", {
      class: _normalizeClass(["sidebar", { 
      collapsed: _ctx.isCollapsed && !_ctx.isMobileOpen, 
      'mobile-open': _ctx.isMobileOpen 
    }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[12] || (_cache[12] = _createElementVNode("img", {
            src: "/logo192.png",
            alt: "OKOLISY",
            class: "logo"
          }, null, -1)),
          (!_ctx.isCollapsed || _ctx.isMobileOpen)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "OKOLISY Admin"))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.isMobileOpen)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "toggle-btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.isCollapsed ? 'chevron-right' : 'chevron-left'
              }, null, 8, ["icon"])
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "toggle-btn close-btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileSidebar && _ctx.toggleMobileSidebar(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "times" })
            ]))
      ]),
      _createElementVNode("nav", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/admin",
          class: "nav-link",
          exact: "",
          onClick: _ctx.closeMobileOnNavigate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "home" }),
            (!_ctx.isCollapsed || _ctx.isMobileOpen)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Tableau de bord"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/admin/annonces",
          class: "nav-link",
          onClick: _ctx.closeMobileOnNavigate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "box" }),
            (!_ctx.isCollapsed || _ctx.isMobileOpen)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Annonces"))
              : _createCommentVNode("", true),
            ((!_ctx.isCollapsed || _ctx.isMobileOpen) && _ctx.stats.annonces > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.stats.annonces), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/admin/utilisateurs",
          class: "nav-link",
          onClick: _ctx.closeMobileOnNavigate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "users" }),
            (!_ctx.isCollapsed || _ctx.isMobileOpen)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Utilisateurs"))
              : _createCommentVNode("", true),
            ((!_ctx.isCollapsed || _ctx.isMobileOpen) && _ctx.stats.users > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.stats.users), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/admin/transactions",
          class: "nav-link",
          onClick: _ctx.closeMobileOnNavigate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "credit-card" }),
            (!_ctx.isCollapsed || _ctx.isMobileOpen)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Transactions"))
              : _createCommentVNode("", true),
            ((!_ctx.isCollapsed || _ctx.isMobileOpen) && _ctx.stats.transactions > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.stats.transactions), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/admin/paiements",
          class: "nav-link",
          onClick: _ctx.closeMobileOnNavigate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "money-bill-wave" }),
            (!_ctx.isCollapsed || _ctx.isMobileOpen)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Paiements vendeurs"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.isSuperAdmin)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!_ctx.isCollapsed || _ctx.isMobileOpen)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Administration"))
                : _createCommentVNode("", true),
              _createVNode(_component_router_link, {
                to: "/admin/admins",
                class: "nav-link",
                onClick: _ctx.closeMobileOnNavigate
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "user-shield" }),
                  (!_ctx.isCollapsed || _ctx.isMobileOpen)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Gestion admins"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_router_link, {
                to: "/admin/settings",
                class: "nav-link",
                onClick: _ctx.closeMobileOnNavigate
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: "cog" }),
                  (!_ctx.isCollapsed || _ctx.isMobileOpen)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Paramètres"))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        (!_ctx.isCollapsed || _ctx.isMobileOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("img", {
                src: _ctx.userAvatar,
                alt: "Admin",
                class: "user-avatar"
              }, null, 8, _hoisted_19),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.adminUser?.pseudo || 'Admin'), 1),
                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.isSuperAdmin ? 'Super Admin' : 'Admin'), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "logout-btn",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "sign-out-alt" }),
          (!_ctx.isCollapsed || _ctx.isMobileOpen)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Déconnexion"))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["main-area", { 'mobile-shifted': _ctx.isMobileOpen }])
    }, [
      _createElementVNode("header", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "mobile-toggle",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileSidebar && _ctx.toggleMobileSidebar(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "bars" }),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "sr-only" }, "Menu", -1))
          ]),
          _createElementVNode("h1", null, _toDisplayString(_ctx.pageTitle), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Rechercher...",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchQuery) = $event)),
              onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.globalSearch && _ctx.globalSearch(...args)), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _createVNode(_component_font_awesome_icon, {
              icon: "search",
              class: "search-icon"
            })
          ]),
          _createElementVNode("div", {
            class: "header-notifications",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.toggleNotifications && _ctx.toggleNotifications(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "bell" }),
            (_ctx.notifications.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.notifications.length), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: "header-user",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.toggleUserMenu && _ctx.toggleUserMenu(...args)))
          }, [
            _createElementVNode("img", {
              src: _ctx.userAvatar,
              alt: "Admin"
            }, null, 8, _hoisted_28),
            _createElementVNode("span", null, _toDisplayString(_ctx.adminUser?.pseudo || 'Admin'), 1),
            _createVNode(_component_font_awesome_icon, {
              icon: "chevron-down",
              class: "chevron"
            })
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_29, [
        _createVNode(_component_router_view)
      ])
    ], 2),
    (_ctx.showNotifications)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "notifications-dropdown",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showNotifications = false))
        }, [
          _createElementVNode("div", {
            class: "notifications-list",
            onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_30, [
              _cache[14] || (_cache[14] = _createElementVNode("h3", null, "Notifications", -1)),
              _createElementVNode("button", {
                class: "mark-read",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.markAllRead && _ctx.markAllRead(...args)))
              }, "Tout marquer comme lu")
            ]),
            (_ctx.notifications.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("p", null, "Aucune notification", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notif) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: notif.id,
                      class: _normalizeClass(["notif-item", { unread: !notif.read }])
                    }, [
                      _createElementVNode("div", {
                        class: "notif-icon",
                        style: _normalizeStyle({ background: notif.color })
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: notif.icon
                        }, null, 8, ["icon"])
                      ], 4),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("p", null, _toDisplayString(notif.message), 1),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.formatTime(notif.created_at)), 1)
                      ])
                    ], 2))
                  }), 128))
                ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}